<template>
  <component-wrapper>
    <grid-container-fi>
      <div class="newsroom-detail-fi__content">
        <headline-fi
          :field="fields.subheadline"
          class="newsroom-detail-fi__overheadline"
          :size="30"
        />
        <headline-fi
          class="newsroom-detail-fi__headline"
          :size="60"
          :field="fields.headline"
        />

        <div class="newsroom-detail-fi__date-container">
          <span
            v-if="date"
            class="badge-fi newsroom-detail-fi__date"
          >
            {{ date }}
          </span>

          <div class="newsroom-detail-fi__location">
            {{ fields?.location?.value }}
          </div>
        </div>

        <richtext-fi
          class="newsroom-detail-fi__text"
          :html-content="fields.text"
        />
      </div>
    </grid-container-fi>

    <newsroom-contact-persons-fi
      class="newsroom-detail-fi__contact-persons"
      :contact-persons="fields?.contact"
      :link="fields?.link"
    />

    <template v-if="fields?.images?.length > 0">
      <section-divider-small-fi />

      <grid-container-fi :container="false">
        <div class="fi-col-span-full">
          <newsroom-media-slider-fi />
        </div>
      </grid-container-fi>
    </template>
  </component-wrapper>
</template>

<script setup lang="ts">
import { HeadlineFi, RichtextFi } from 'atoms';
import { computed } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import NewsroomContactPersonsFi from '@/components/newsroom-contact-person-fi/NewsroomContactPersonsFi.vue';
import NewsroomMediaSliderFi from '@/components/newsroom-media-slider-fi/NewsroomMediaSliderFi.vue';
import { useFields } from '@/composables/fields';
import { useFischer } from '@/composables/fischerPlugin';
import SectionDividerSmallFi from '@/pages/section-divider-fi/SectionDividerSmallFi.vue';

defineOptions({ name: 'NewsroomDetailFi' });

const props = withDefaults(
  defineProps<{
    customData?: Record<string, any> | null;
  }>(),
  {
    customData: null,
  },
);

const fields = useFields('NewsroomDetailFiFields');
const fischer = useFischer();

const date = computed(() => {
  const raw = IS_SHOWROOM ? '2023-10-23T18:25:43.511Z' : props.customData?.PressDate;

  if (!raw) {
    return null;
  }

  // The site's locale, not the runtime's - an implicit one gives Node's format on the server and the
  // visitor's in the browser. NewsroomGroupPageFi formats the same dates this way.
  return new Date(raw).toLocaleDateString(fischer.siteLanguage());
});
</script>

<style scoped src="./newsroom-detail-fi" />
